<template>
    <div class="viewport">
        <div class="container">
            <h1 class="viewport-header">
                <div class="flex absolute watermark">ZÁKAZKY</div>
                Najnovšie obstarávania
            </h1>
            <CTableToolbar class="full-width gt-sm">
                <q-item-section class="col1">
                    <q-item-label class="ellipsis">Názov zákazky</q-item-label>
                </q-item-section>
                <q-item-section
                    side
                    class="col2"
                >
                    <q-item-label class="ellipsis">Lehota na predkladanie</q-item-label>
                </q-item-section>
                <q-item-section
                    side
                    class="col3"
                >
                    <q-item-label class="ellipsis">Obstarávateľ</q-item-label>
                </q-item-section>
            </CTableToolbar>

            <div class="full-width">
                <div
                    v-if="$e.is.empty(displayed)"
                    class="noDataPanel"
                >
                    Žiadne dáta na zobrazenie
                </div>
                <Animation
                    v-else
                    v-for="(item, index) of displayed"
                    :key="item.orderId"
                    animationName="animate__fadeInUp"
                    inView
                    :delay="index * 0.1 + 's'"
                >
                    <CTableItem @click="$q.screen.lt.md ? enterToItem(item) : null">
                        <q-item-section
                            data-label="Názov zákazky:"
                            class="col1"
                        >
                            <router-link
                                :to="{ name: 'zakazka', params: { id: item.orderId } }"
                                class="ellipsis"
                            >
                                {{ item.name }}
                            </router-link>
                        </q-item-section>
                        <q-item-section
                            data-label="Lehota na predkladanie:"
                            side
                            class="col2"
                        >
                            <span
                                class="ellipsis"
                                style="min-height: 24px"
                                >{{ item.offersDeadlineDateTime?.dateTimeShort || '--' }}</span
                            >
                        </q-item-section>
                        <q-item-section
                            data-label="Obstarávateľ:"
                            side
                            class="col3"
                        >
                            <span class="ellipsis-2-lines">{{ item.organization.name }}</span>
                        </q-item-section>
                    </CTableItem>
                </Animation>
            </div>

            <div class="buttonPanel row q-gutter-sm justify-center">
                <Animation
                    animationName="animate__fadeInUp"
                    inView
                    delay="0.9s"
                >
                    <CButton
                        color="primary"
                        label="Zobraziť ďalšie obstarávania"
                        @click="$emit('show-more')"
                    />
                </Animation>
            </div>
        </div>
    </div>
</template>

<script>
import Animation from '@/components/animation.vue';
import CButton from '@/components/CButton.vue';
import CTableItem from '@/components/CTableItem.vue';
import CTableToolbar from '@/components/CTableToolbar.vue';

export default {
    components: {
        Animation,
        CButton,
        CTableItem,
        CTableToolbar,
    },
    props: {
        obstaravania: Array,
    },
    computed: {
        displayed() {
            return this.obstaravania.slice(0, 7);
        },
    },
    methods: {
        enterToItem(item) {
            this.$router.push({ name: 'zakazka', params: { id: item.orderId } });
        },
    },
};
</script>

<style lang="scss" scoped>
.viewport {
    background-image: url('@/assets/vlnka.svg');
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: 100%;

    @media (max-width: $breakpoint-xs-max) {
        background-size: cover;
    }
}

.q-item {
    .col1 {
        width: 400px;
    }
    .col2 {
        width: 250px;
    }
    .col3 {
        width: 400px;
    }
}

@media (max-width: $breakpoint-sm-max) {
    .tableItemBlock {
        height: 242px;
    }
}
</style>
